/**
 * DetailHeader component.
 */
import AppLogo from '@components/atoms/images/detailAppLogo';
import Container from '@components/atoms/container/detailHeaderContainer';
import Context from '@shared/components/utils/context/detailContext';
import Clock from '@components/atoms/text/detailClock';
import Photo from '@components/atoms/images/detailPhoto';
import { useContext } from 'react';

/**
 * Displays the detail header. Includes the photo, clock, and logo.
 */
export default function DetailHeader() {
  const { complete, metadata } = useContext(Context);
  return (
    <>
      <Photo src={complete ? metadata?.background || '' : ''} />
      <Container>
        <Clock />
        <AppLogo />
      </Container>
    </>
  );
}
